









import { Component, Vue, Provide, InjectReactive, Inject, Prop } from 'vue-property-decorator';
import { uuid } from '@/utils';

@Component({ name: 'accordion-item' })
export default class AccordionItemComponent extends Vue {
  @Prop({ required: true }) public title!: string;
  @Inject() public getSelected!: () => string;
  @Inject() public setSelected!: (key: string) => void;

  public id: string = uuid();
  public get isActive(): boolean { return this.getSelected() === this.id; }
}
